import { PillTabs } from "@/components/common";
import { useTran } from "@/hooks";

const OPTIONS = [
  { value: "organization", label: "Organization" },
  { value: "metric", label: "Metric" },
];

const OverviewViewToggle = ({ value, onChange }) => {
  const { t } = useTran();
  const tabs = OPTIONS.map((o) => ({ value: o.value, label: t(o.label) }));
  return (
    <div className="flex items-center gap-2">
      <span className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
        {t("View by")}
      </span>
      <PillTabs tabs={tabs} value={value} onChange={onChange} size="sm" />
    </div>
  );
};

export default OverviewViewToggle;
